const $ = require('jquery')

const { BREAKPOINT } = require('./api')

function runStickyActions (stickyWidget, stickyTabs, stickyWidgetPosRight) {
  const containerW = $('main > .container').width()
  const headerHeight = $('.header').outerHeight()
  stickyTabs = $('ul.offer-tabs__nav')
  stickyWidget = $('.offer-content__sidebar')
  stickyWidgetPosRight = (($(window).width() - containerW) / 2)

  if (window.innerWidth > BREAKPOINT.DESKTOP) {
    stickyTabs.stick_in_parent({
      /* eslint-disable camelcase */
      offset_top: headerHeight,
      /* eslint-enable camelcase */
    }).on('sticky_kit:stick', function() {
      $(this).css('z-index', '100')
    })

    stickyWidget
      .stick_in_parent({
        /* eslint-disable camelcase */
        offset_top: headerHeight,
        /* eslint-enable camelcase */
        parent: $('main > .container'),
      })
      .on('sticky_kit:stick', function() {
        $(this).css('right', stickyWidgetPosRight)
      })
      .on('sticky_kit:unstick', function() {
        $(this).css('right', 0)
      })
      .on('sticky_kit:bottom', function() {
        $(this).css('right', 0)
      })
      .on('sticky_kit:unbottom', function() {
        $(this).css('right', stickyWidgetPosRight)
      })
  } else {
    stickyWidget.trigger('sticky_kit:detach')
    stickyWidget.css({
      right: '0',
      top: '0',
    })
    stickyTabs.trigger('sticky_kit:detach')
    stickyTabs.css('top', '0')
  }
}

// =========================================================================
// Sticky elements in offer
// =========================================================================
function init () {
  $(document).on('readystatechange', function() {
    if (document.readyState === 'complete') {
      runStickyActions()
    }
  })

  $(window).resize(function() {
    return runStickyActions()
  })
}

module.exports = {
  init,
}



// WEBPACK FOOTER //
// ./src/modules/stickyOffer.js